import React from "react";
import "./NftChoose.css";
import chooseimage from "../marketplaceassets/chooseimg.png";
import check from "../marketplaceassets/check.png";

export default function NftChoose() {
  return (
    <div id="marketplace-choose" className="marketmainclass">
      <div className="left">
        <h1 className="heading">Why Work With Us</h1>
        <p>
         A reliable partner for NFT marketplace development, delivering secure, scalable, and high-performance platforms that support long-term growth in the Web3 ecosystem. Each solution is designed with a strong focus on usability, security, and future scalability.
        </p>

        <ul>
          <li>
            <img src={check} alt="error" />
            <span>Experienced Blockchain Team</span>
          </li>
          <li>
            <img src={check} alt="error" />
            <span>End-to-End Development</span>
          </li>
          <li>
            <img src={check} alt="error" />
            <span>Secure Architecture</span>
          </li>
          <li>
            <img src={check} alt="error" />
            <span>Scalable Solutions</span>
          </li>
          <li>
            <img src={check} alt="error" />
            <span>Cost-Effective Engagement Models</span>
          </li>
          <li>
            <img src={check} alt="error" />
            <span>Reliable Post-Launch Support</span>
          </li>
        </ul>
      </div>
      <div className="right">
        <img src={chooseimage} alt="error" />
      </div>
    </div>
  );
}
